export const i18nInstance = window.i18nConfig;